import {Component} from '@angular/core';
import {AbstractTool} from 'app/tool-layer/class/abstract-tool';

@Component({
    selector: 'app-tddhte',
    templateUrl: './tddhte.component.html',
    styleUrls: ['./tddhte.component.scss'],
})
export class TddhteComponent extends AbstractTool {
    public static readonly id = 'tddhte';
    public static readonly width = 180;
    public static readonly height = 95;
    public rangeModel = {
        Td: 0,
        D: 0,
        H: 0,
        T: 0,
        E: 0,
    };

    constructor() {
        super();
    }
}
